export default __webpack_public_path__ + "images/efbfb744d25b0a341215da8947406b64.svg";